import { Injectable } from "@angular/core";
import { LoginResponse } from "../../models/auth.model";

@Injectable({ providedIn: 'root' })
export class AuthorizationService {
    private static loginResponseKey = 'loginResponse';

    public authInfo: LoginResponse | null = null;

    public get hasExpiredToken(): boolean {
        return new Date() > new Date(this.authInfo!.tokenExpiryOn);
    }

    public get hasValidToken(): boolean {
        return this.hasAuthenticated && !this.hasExpiredToken;
    }

    public get hasValidLoginToken(): boolean {
        const loginInfo = this.loginResponse;
        if (loginInfo == null) {
            return false;
        }
        if (new Date() > new Date(loginInfo.tokenExpiryOn)) {
            return false;
        }
        return true;
    }

    public setLoginResponse(loginResponse: LoginResponse): void {
        this.authInfo = loginResponse;
        localStorage.setItem(AuthorizationService.loginResponseKey, JSON.stringify(loginResponse));
    }

    public updateAuth(loginResponse: LoginResponse): void {
        this.setLoginResponse({
            ...this.authInfo,
            ...loginResponse
        });
    }

    public getAuthToken(): string {
        if (this.hasAuthenticated) {
            return 'Bearer ' + this.authInfo?.token;
        }
        return "";
    }

    public getLoginToken(): string | null {
        if (this.hasValidLoginToken) {
            return 'Bearer ' + this.loginResponse?.token;
        }
        return null;
    }

    public get loginResponse(): LoginResponse | null {
        let auth = localStorage.getItem(AuthorizationService.loginResponseKey)
        if (auth != null) {
            return JSON.parse(auth) as LoginResponse;
        }
        return null;
    }

    public logOut(): void {
        localStorage.removeItem(AuthorizationService.loginResponseKey);
        this.authInfo = null;
    }

    private get hasAuthenticated(): boolean {
        if (this.authInfo == null) {
            var auth = localStorage.getItem(AuthorizationService.loginResponseKey);
            if (auth) {
                this.authInfo = JSON.parse(auth);
            }
        }
        return this.authInfo != null;
    }
}
